import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSettingsStore } from '../stores/settingsStore';

export function useLanguageSync() {
  const { i18n } = useTranslation();
  const { language, setLanguage } = useSettingsStore();

  // Sync Zustand store language to i18next on mount and when store changes
  useEffect(() => {
    if (i18n.language !== language) {
      i18n.changeLanguage(language);
    }
  }, [language, i18n]);

  // Sync i18next language changes back to Zustand store
  useEffect(() => {
    const handleLanguageChanged = (lng: string) => {
      const normalizedLng = lng.startsWith('ru') ? 'ru' : 'en';
      if (normalizedLng !== language) {
        setLanguage(normalizedLng);
      }
    };

    i18n.on('languageChanged', handleLanguageChanged);
    return () => {
      i18n.off('languageChanged', handleLanguageChanged);
    };
  }, [i18n, language, setLanguage]);
}
